var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1051 2.58876L8.3506 21.704C7.85096 23.118 8.89991 24.6012 10.3996 24.6012H18.3223L15.7674 36.7773C15.4503 38.2888 17.4008 39.1829 18.339 37.9562L30.4562 22.1103C31.5497 20.6804 30.5301 18.6171 28.7299 18.6171H22.3806L31.5168 4.03952C32.2175 2.92158 31.4138 1.46948 30.0945 1.46948H16.6879C15.9764 1.46941 15.3422 1.91797 15.1051 2.58876Z",
    fill: "#F9EF63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2104 38.1049C17.235 39.1041 15.4647 38.2234 15.7675 36.7774L18.3223 24.6013H19.0754C19.7443 24.6013 20.2439 25.2166 20.1065 25.8712L17.8182 36.7774C17.7033 37.3248 17.886 37.7916 18.2104 38.1049Z",
    fill: "#F1D333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3291 1.46973C20.6177 1.46973 19.983 1.91792 19.7459 2.58908L12.9911 21.7041C12.4915 23.1181 13.5408 24.6013 15.0404 24.6013H10.3997C8.9001 24.6013 7.85084 23.118 8.35049 21.7041L15.1052 2.58908C15.3424 1.91792 15.9763 1.46973 16.6876 1.46973H21.3291Z",
    fill: "#F1D333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/boost.07d60254251d818e2fa1ee4b3a7f829a.svg";
export { ForwardRef as ReactComponent };